<template>
    <component :is="slug ? 'router-link' : 'div'" :to="slug ? { name : 'ProductDetail', params : { slug } } : undefined" class="product-line">
        <div class="product-line-img">
            <img :src="img" :alt="name.replace(/<[^>]*>/g, '')" />
        </div>
        <div class="product-line-info">
            <h3 v-html="name"></h3>
            <div class="product-line-sep"></div>
            <div class="product-line-tagline">
                <i class="fa-solid fa-chevron-right chevron-icon"></i>
                <p v-html="tagline"></p>
            </div>
        </div>
    </component>
</template>

<script>
export default {
    name : "ProductLineItem",
    props : ["img", "name", "tagline", "slug"]
}
</script>

<style scoped lang="scss">
.product-line {
    display: flex;
    align-items: center;
    justify-content: center;
    width: $box;
    max-width: 90%;
    margin: 60px auto;
}

.product-line-img {
    position: relative;
    width: 35%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 0;
}

.product-line-img::before {
    content: "";
    position: absolute;
    inset: 0;
    background: radial-gradient(circle, rgba(128, 189, 1, 0.15) 0%, rgba(128, 189, 1, 0) 70%);
}

.product-line-img img {
    position: relative;
    max-width: 70%;
    max-height: 220px;
}

.product-line-info {
    width: 65%;
    padding: 0 20px;
}

h3 {
    color: #fff;
    font-size: 24px;
    font-weight: 400;
    margin: 0;
}

h3 :deep(.colored) {
    color: $mainColor;
}

.product-line-sep {
    width: 120px;
    height: 1px;
    background: $mainColor;
    margin: 15px 0;
}

.product-line-tagline {
    display: flex;
    align-items: flex-start;
}

.chevron-icon {
    font-size: 13px;
    color: $mainColor;
    margin-right: 10px;
    margin-top: 5px;
}

.product-line-tagline p {
    margin: 0;
    color: #fff;
    font-size: 15px;
    font-weight: 300;
    line-height: 1.5em;
}

@media screen and (max-width:768px) {
    .product-line {
        flex-direction: column;
        margin: 30px auto;
    }

    .product-line-img, .product-line-info {
        width: 100%;
    }

    .product-line-info {
        text-align: center;
        margin-top: 15px;
    }

    .product-line-sep {
        margin: 15px auto;
    }

    .product-line-tagline {
        justify-content: center;
    }
}
</style>
